import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { getLangPath } from '../../router/langRoutes';

/**
 * Component redirect từ root `/` sang `/{lang}/` tương ứng
 */
export default function RootRedirect() {
  const navigate = useNavigate();
  const { i18n } = useTranslation();

  useEffect(() => {
    // Lấy ngôn ngữ từ localStorage hoặc dùng ngôn ngữ hiện tại
    const savedLang = localStorage.getItem('language') || i18n.language || 'vi';
    const homePath = getLangPath('home', savedLang);
    navigate(homePath, { replace: true });
  }, [navigate, i18n.language]);

  return <div className="min-h-screen bg-white" />;
}